export const painPoints: string[] = [
  'Te sentás a la mesa familiar y mirás los platos sin saber qué podés comer.',
  'Buscás recetas online y todo viene con ingredientes que no conseguís en ningún lado.',
  'Comés lo mismo todos los días porque “al menos eso sé que no me hace mal”.',
  'Alguien cocina para vos y no sabe cómo adaptarlo: termina haciendo una comida aparte.',
  'Llegás a los cumpleaños, los asados, las fiestas y no sabés cómo manejarte.',
  'Tu glucosa sigue inestable aunque comés “bien”, porque nadie te explicó cómo combinar.',
  'Dejaste de disfrutar la comida. Comer se convirtió en una obligación con miedo.',
]

export const mechanismPillars: string[] = [
  'Reemplazos simples de ingredientes con alto índice glucémico.',
  'Combinaciones que estabilizan el azúcar en sangre sin que lo notes.',
  'Porciones calibradas para que comas bien y no pases hambre.',
  'Adaptaciones de cada plato típico argentino — el asado, las empanadas, las medialunas, la carbonada, el flan — para que sigan siendo lo que siempre fueron: placer, no problema.',
]
